export * from './ScoreCardView';


// WEBPACK FOOTER //
// ./src/components/reports/scoreCard/index.tsx